module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sekundærlogo_sentrert_logo_neg.a78af5b6.pdf";